/** Why the watermark text cannot be used yet, or null when it can. Shown next to the box and used to disable the button. */
export function watermarkTextProblem(text: string): string | null {
  return text.replace(/[\r\n\t]+/g, " ").trim() ? null : "Type the watermark text";
}
